module.exports = __webpack_public_path__ + "static/media/k-contents.5a419419.svg";